import React from "react";
import { NewsList } from "../components/News";

export function News(props) {
    return (
        <div className="content-container">
            <div className="section-top">
                <h1>Nieuws</h1>
            </div>
            <NewsList />
        </div>
    );
}
